export interface BetaOption {
  name: string
  label: string
  globallyEnabled: boolean
  description?: string
  hidden?: boolean
}

export const betaOptions: BetaOption[] = [
  {
    name: 'favorites',
    label: 'Favorites',
    globallyEnabled: false,
    hidden: true,
  },
  {
    name: 'modernUi',
    label: 'Modern UI',
    globallyEnabled: false,
    description: 'Try the redesigned interface. Switch back any time.',
  },
]
